import React, { FC } from "react";
import { IOptionSelect, OptionValue, SetOptionValue } from "src/@types/form";
import { CheckboxSelectorItem } from "./CheckboxSelectorItem";

interface Props {
  options: IOptionSelect[];
  activeValue: OptionValue;
  setActiveValue: SetOptionValue;
}
export const SingleCheckboxSelector: FC<Props> = ({
  options,
  activeValue,
  setActiveValue,
}) => {
  const isChecked = (value: OptionValue) => value === activeValue;
  const handleClick = (value: OptionValue) => () => setActiveValue(value);

  return (
    <div className="flex flex-col gap-5 items-start max-w-96 w-full md:flex-row md:justify-between">
      {options.map((option) => (
        <CheckboxSelectorItem
          key={option.id}
          option={option}
          checked={isChecked(option?.value)}
          onClick={handleClick(option?.value)}
        />
      ))}
    </div>
  );
};
